export interface DeliveryLocation {
  latitude: number;
  longitude: number;
  street_name?: string | null;
  building_number?: string | null;
  floor_number?: string | null;
  apartment_number?: string | null;
  geocode_address?: string | null;
  details?: string | null;
}

export interface PlaceOrderParams {
  cart_id: string;
  restaurant_id?: string | null;
  branch_id?: string | null;
  order_type: string;
  payment_method: string;
  // Customer info
  customer_name?: string | null;
  customer_phone: string;
  customer_email?: string | null;
  // Delivery location (required when order_type is "delivery")
  delivery_location?: DeliveryLocation | null;
  // Additional fields
  notes?: string | null;
  scheduled_at?: string | null;
  promo_code?: string | null;
  discount_amount?: number | null;
  country_code?: string | null;
}

export interface PlaceOrderResult {
  success: boolean;
  data?: {
    order_id: string;
    order_number: string;
    order_payment_url?: string;
    firebase_path?: string;
    branch_status?: { is_open: boolean; is_busy: boolean; reason?: string | null } | null;
  };
  branch_status?: { is_open: boolean; is_busy: boolean; reason?: string | null } | null;
  error?: { code: string; message: string };
}

export async function placeOrder(params: PlaceOrderParams): Promise<PlaceOrderResult> {
  try {
    //const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseUrl = window.location.origin;
    const anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

    if (!supabaseUrl || !anonKey) {
      return {
        success: false,
        error: { code: "CONFIG_ERROR", message: "Missing backend configuration" },
      };
    }

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30_000);

    const response = await fetch(
      //`${supabaseUrl}/functions/v1/place-order`, 
      `${window.location.origin}/api/WebOrder/functions/v1/place-order`,
      {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        apikey: anonKey,
        Authorization: `Bearer ${anonKey}`,
      },
      body: JSON.stringify(params),
      signal: controller.signal,
    });

    clearTimeout(timeout);
    const json = await response.json();

    if (response.ok && json.success) {
      return { success: true, data: json.data, branch_status: json.data?.branch_status ?? null };
    }

    return {
      success: false,
      branch_status: json.branch_status ?? null,
      error: json.error || { code: "UNKNOWN", message: "Unexpected response" },
    };
  } catch (err: any) {
    return {
      success: false,
      error: {
        code: err.name === "AbortError" ? "TIMEOUT" : "NETWORK_ERROR",
        message: err.message || "Network request failed",
      },
    };
  }
}
